export default __webpack_public_path__ + "static/media/No85.78e25595.jpg";